import { ConfirmationService } from 'primeng/api';
import { Component, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-item-confirm',
  templateUrl: './item-confirm.component.html',
  styleUrls: ['./item-confirm.component.scss']
})
export class ItemConfirmComponent {
    @Input()
    public header = '';
    @Input()
    public key: string = null;
    @Input()
    public icon: string = null;
    @Input()
    public message: string;
    @Input()
    public severity = 'alert';

    @Output()
    public onAccept: EventEmitter<any> = new EventEmitter();
    @Output()
    public onReject: EventEmitter<any> = new EventEmitter();

    constructor(private confirmationService: ConfirmationService) { }

    confirmAction(key, message, acceptCallback?, rejectCallback?) {
        if (this.icon === null) {
            switch (this.severity) {
                case 'alert':
                case 'warning':
                    this.icon =  'pi pi-exclamation-triangle';
                    break;
                case 'info':
                    this.icon =  '';
                    break;
                default:
                    this.icon =  null;
                    break;
            }
        }
        this.confirmationService.confirm({
            key: key,
            icon: this.icon,
            message: message,
            accept: () => {
                this.onAccept.emit();
                if (acceptCallback) {
                    acceptCallback();
                }
            },
            reject: () => {
                this.onReject.emit();
                if (rejectCallback) {
                    rejectCallback();
                }
            }
        });
    }
}
